import React, { useRef, useState, useEffect, useLayoutEffect } from "react";
import MiniSideBar from "../../components/mini-sidebar";
import {
  Box,
  Flex,
  Image,
  Menu,
  MenuButton,
  Text,
  MenuList,
  MenuItem,
  Td,
  Tr,
  Textarea,
  Card,
  CardBody,
  Divider,
  Input,
  SimpleGrid,
  Center,
} from "@chakra-ui/react";
import SecondaryNav from "../../components/seconday-nav";
import PrimaryButton from "../../components/primary-button";
import DynamicModal from "../../components/dynamic-modal";
import ModalRight from "../../components/modal-right";
import useLoader from "../../components/loader/loaderstates";
import Loader from "../../components/loader/loader";
import SimpleTable from "../../components/simple-table";
import {
  DropdownInput,
  PasswordInput,
  PrimaryInput,
  PrimaryInputDropdown,
  SearchBar,
  Toaster,
} from "../../components";

import { BrowserRouter as Router, useNavigate } from "react-router-dom";

import MobileNavbar from "../../components/mobile-navbar";
import MobileSecondaryNav from "../../components/mobile-secondary-navbar";
import {
  formatDate_DD_MM_YYYY,
  formatDate_YYYY_MM_DD,
  getCroppedImg,
  getLoginID,
  handleAlphaDotAndSpace,
  handleNumericDotAndSpace,
  useScreenType,
} from "../../auth";
import {
  AddReferHospitals,
  DeleteReferHospitals,
  GetReferHospitals,
  UpdateReferHospitals,
} from "../../middleware/services/referhospitals";
import {
  addClinic,
  FetchDoctorClinics,
  getProfile,
  saveClinicChanges,
  saveClinicDeletedChanges,
  saveClinicEditedChanges,
  updateClinic,
  updatePartnerLogoOnChange,
  uploadPartnerImageInProfile,
} from "../../middleware/services/profile";
import ImageCropper from "../profile/ImageCropper";
import { format } from "date-fns";
import DatePicker from "../../components/date-picker";

const MasterBranches = () => {
  const { isLoading, showLoader, dismissLoader } = useLoader();
  const { showSuccessToast, showErrorToast } = Toaster();

  const screenType = useScreenType();
  const navigate = useNavigate();
  const [resultBranch, setResultBranch] = useState([]);
  const [firstname, setfirstname] = useState(null);
  const [lastname, setlastname] = useState(null);
  const [gender, setGender] = useState(null);
  const [dobBranch, setDobBranch] = useState(null);

  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const [mobileno, setmobileno] = useState(null);

  const [countryid, setcountryid] = useState(null);
  const [countrycode, setcountrycode] = useState(null);

  const [branchName, setBranchName] = useState(null);
  const [branchAddress1, setBranchAddress1] = useState(null);
  const [branchAddress2, setBranchAddress2] = useState(null);
  const [branchCity, setBranchCity] = useState(null);
  const [branchState, setBranchState] = useState(null);
  const [branchPinCode, setBranchPinCode] = useState(null);
  const [branchCountry, setBranchCountry] = useState(null);

  const [genderId, setGenderId] = useState(null);
  const [branchid, setbranchid] = useState(null);
  const [refreshPageData, setRefreshPageData] = useState(false);
  const [searchValue, setSearchValue] = useState([]);

  const addBranch = useRef();
  const editBranch = useRef();

  const getDoctorProfile = async () => {
    var inputForGet = {};
    showLoader();
    try {
      var result = await getProfile(inputForGet);

      if (result && result.resultbranch) {
        setResultBranch(result.resultbranch);
        console.log(result.resultbranch, "result of doctor profile");
      }
    } catch (error) {
      console.log(error, "Something went wrong in doctor profile");
    } finally {
      dismissLoader();
    }
  };

  function clearState() {
    setfirstname(null);
    setlastname(null);
    setEmail(null);
    setPassword(null);
    setGender(null);
    setDobBranch(null);
    setmobileno(null);
    setBranchName(null);
    setBranchAddress1(null);
    setBranchAddress2(null);
    setBranchCity(null);
    setBranchState(null);
    setBranchPinCode(null);
    setBranchCountry(null);
    setbranchid(null);
  }
  const handleDateChange = (date) => {
    setDobBranch(date);
  };
  const selectGender = (selectedOption) => {
    if (selectedOption == "Male") {
      setGender("Male");
      setGenderId("2");
    } else if (selectedOption == "Female") {
      setGender("Female");
      setGenderId("1");
    } else if (selectedOption == "Others") {
      setGender("Others");
      setGenderId("3");
    }
  };
  const handleMobileChange = (e) => {
    var countryCode = localStorage.getItem("countrycode");
    var countryId = localStorage.getItem("countryid");

    setcountryid(countryCode);
    setcountrycode(countryId);

    setmobileno(e.target.value.replace(/[^0-9]/g, "").slice(0, 11));
  };

  const openAddBranchModal = () => {
    clearState();
    addBranch.current.openRight();
  };

  async function addBranchFunction() {
    if (!firstname) {
      showErrorToast("Please Enter First Name!");
      return false;
    } else if (!email) {
      showErrorToast("Please enter Email!");
      return false;
    } else if (!password) {
      showErrorToast("Please enter Password!");
      return false;
    } else if (!gender) {
      showErrorToast("Please enter Gender!");
      return false;
    } else if (!mobileno) {
      showErrorToast("Please enter Phone No.!");
      return false;
    } else if (!branchName) {
      showErrorToast("Please enter Branch Name!");
      return false;
    } else if (!branchAddress1) {
      showErrorToast("Please enter Branch Address 1!");
      return false;
    } else if (!branchCity) {
      showErrorToast("Please enter Branch City!");
      return false;
    } else if (!branchState) {
      showErrorToast("Please enter Branch State!");
      return false;
    } else if (!branchPinCode) {
      showErrorToast("Please enter Branch Pin code!");
      return false;
    } else if (!branchCountry) {
      showErrorToast("Please enter Branch Country!");
      return false;
    }
    showLoader();
    let addBranchInput = {
      firstname: firstname,
      lastname: lastname,
      gender: genderId,
      dob: dobBranch,
      email: email,
      password: password,
      mobileno: mobileno,
      countryid: countryid,
      countrycode: countrycode,
      branchname: branchName,
      address1: branchAddress1,
      address2: branchAddress2,
      pincode: branchPinCode,
      city: branchCity,
      state: branchState,
      country: branchCountry,
      roleid: 1,
      loginid: "",

      latitude: "",
      longitude: "",
    };
    try {
      if (dobBranch) {
        const formattedDate = format(dobBranch, "yyyy-MM-dd");
        addBranchInput.dob = formattedDate;
      }
      let result = await addClinic(addBranchInput);
      // console.log(result, " result of add branch.");
      if (result.output.result == "success") {
        showSuccessToast("Branch added Successfully!");
        setRefreshPageData(!refreshPageData);
        addBranch.current.closeRight();
      } else if (
        result.output.message ==
        "doctor user already exists with this email/mobile number"
      ) {
        showErrorToast(
          "Doctor user already exists with this email/mobile number!"
        );
      } else {
        showErrorToast("Something went Wrong!");
      }
    } catch (error) {
      console.log(error, " error in creating branch");
    }
    dismissLoader();
  }
  async function editBranchFunction() {
    if (!firstname) {
      showErrorToast("Please Enter First Name!");
      return false;
    } else if (!email) {
      showErrorToast("Please enter Email!");
      return false;
    } else if (!gender) {
      showErrorToast("Please enter Gender!");
      return false;
    } else if (!mobileno) {
      showErrorToast("Please enter Phone No.!");
      return false;
    } else if (!branchName) {
      showErrorToast("Please enter Branch Name!");
      return false;
    } else if (!branchAddress1) {
      showErrorToast("Please enter Branch Address 1!");
      return false;
    } else if (!branchCity) {
      showErrorToast("Please enter Branch City!");
      return false;
    } else if (!branchPinCode) {
      showErrorToast("Please enter Branch Pin code!");
      return false;
    } else if (!branchCountry) {
      showErrorToast("Please enter Branch Country!");
      return false;
    }
    showLoader();
    let editBranchInput = {
      id: branchid,
      firstname: firstname,
      lastname: lastname,
      gender: genderId,
      dob: dobBranch,
      email: email,
      password: password,
      mobileno: mobileno,
      countryid: countryid,
      countrycode: countrycode,
      branchname: branchName,
      address1: branchAddress1,
      address2: branchAddress2,
      pincode: branchPinCode,
      city: branchCity,
      state: branchState,
      country: branchCountry,
      roleid: 1,
      loginid: "",

      latitude: "",
      longitude: "",
    };
    try {
      if (dobBranch) {
        const formattedDate = formatDate_YYYY_MM_DD(dobBranch);
        editBranchInput.dob = formattedDate;
      }
      let result = await updateClinic(editBranchInput);

      if (result.output.result == "Success") {
        showSuccessToast("Branch updated Successfully!");
        setRefreshPageData(!refreshPageData);
        addBranch.current.closeRight();
        editBranch.current.closeRight();
      } else if (
        result.output.message ==
        "doctor user already exists with this email/mobile number"
      ) {
        showErrorToast(
          "Doctor user already exists with this email/mobile number!"
        );
      } else {
        showErrorToast("Something went Wrong!");
      }
    } catch (error) {
      console.log(error, " error in editing branch");
    }

    // console.log(input , " add branch input")

    dismissLoader();
  }
  function openEditBranch(item) {
    setbranchid(item.branchid);
    setfirstname(item.firstname);
    setlastname(item.lastname);
    setEmail(item.email);
    setPassword(item.password);
    setGender(item.gender == 2 ? "Male" : item.gender == 1 ? "Female" : "Others");
    if (item.dob) {
      let DobDefault = formatDate_DD_MM_YYYY(item.dob);
      setDobBranch(DobDefault);
    }
    setmobileno(item.mobileno);
    setBranchName(item.clinicname);
    setBranchAddress1(item.address);
    setBranchAddress2(item.address2);
    setBranchCity(item.city);
    setBranchState(item.STATE);
    setBranchPinCode(item.postalcode);
    setBranchCountry(item.country);
    editBranch.current.openRight();
  }

  const handleChangeName = (event) => {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/[^A-Za-z0-9\s@._-]/g, "").slice(0, 50);
    setSearchValue(inputValue);
  };

  async function handleFilter() {
    const trimmedName = searchValue?.trim();
    const inputToFetch = {
      input: {
        doctorid: getLoginID(),
        searchtext: trimmedName,
      },
    };
    showLoader();
    try {
      const result = await getProfile(inputToFetch.input);
      if (result && result.resultbranch) {
        setResultBranch(result.resultbranch);
      }
    } catch (error) {
      console.log("Error fetching Refer center data", error);
    }
    dismissLoader();
  }

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleFilter();
    }
  };

  async function resetFeilds() {
    setSearchValue("");
    getDoctorProfile();
  }

  useEffect(() => {
    getDoctorProfile();
  }, [refreshPageData]);
  return (
    <>
      {screenType === "web" ? (
        <Box w="100%">
          <Flex>
            <Box w="6rem">
              <MiniSideBar />
            </Box>
            {isLoading && <Loader />}
            <Box w="100%">
              <SecondaryNav customHeader="Locations" />
              <Box
                gap="10px"
                my="1rem"
                px="1rem"
                w="100%"
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Box
                  gap="10px"
                  // pl="1rem"
                  w="100%"
                  display="flex"
                  flexDirection="row"
                  justifyContent="start"
                  alignItems="center"
                >
                  <PrimaryInput
                    variant="fullRound"
                    title="Search by Branch, Admin, Address"
                    inputPlace="Search by Branch, Admin, Address"
                    id={"searchName"}
                    inputStyleCss={{ w: "350px" }}
                    onKeyDown={handleKeyDown}
                    onChange={(e) => handleChangeName(e)}
                    inputValue={searchValue}
                  />
                  <PrimaryButton
                    buttonText="Filter"
                    id="filterButton"
                    onClick={() => handleFilter()}
                    btnStyle={{ m: "0", w: "125px" }}
                  />
                  <PrimaryButton
                    buttonText="Reset"
                    id="resetButton"
                    variant="grayBtnFull"
                    btnStyle={{ color: "#AA2F27", m: "0", w: "125px" }}
                    onClick={() => resetFeilds()}
                  />
                </Box>
                <PrimaryButton
                  buttonText="Prescription Templates"
                  onClick={() => navigate("/prescriptiontemplates")}
                  variant="mdBtnFull"
                  btnIcon="/assets/svgs/new-tab.svg"
                  iconSrc={true}
                  iconSrcStyle={{ w: "14px" }}
                  btnStyle={{ w: "280px" }}
                  //  isDisabled={actionAccess && !actionAccess.create ? true : false}
                />
                <PrimaryButton
                  buttonText="Referring Centers"
                  onClick={() => navigate("/referhospitals")}
                  variant="mdBtnFull"
                  btnIcon="/assets/svgs/new-tab.svg"
                  iconSrc={true}
                  iconSrcStyle={{ w: "14px" }}
                  btnStyle={{ w: "220px" }}
                  //  isDisabled={actionAccess && !actionAccess.create ? true : false}
                />
                <PrimaryButton
                  buttonText="Partners"
                  onClick={() => navigate("/partners")}
                  variant="mdBtnFull"
                  btnIcon="/assets/svgs/new-tab.svg"
                  iconSrc={true}
                  iconSrcStyle={{ w: "14px" }}
                  btnStyle={{ w: "120px" }}
                  //  isDisabled={actionAccess && !actionAccess.create ? true : false}
                />
                <PrimaryButton
                  buttonText="Add Branch"
                  onClick={openAddBranchModal}
                  btnStyle={{ m: "0" }}
                  w="125px"
                  //   isDisabled={ actionAccess && (!actionAccess.create) ? true : false}
                />
              </Box>
              <Divider />
              {resultBranch && resultBranch.length > 0 ? (
                <>
                  <Box
                    width="100%"
                    p="1rem"
                    overflow="hidden auto"
                    h="calc(100vh - 155px)"
                  >
                    <SimpleGrid
                      columns={{ base: 1, md: 2, lg: 3, xl: 4 }}
                      spacing="1rem"
                    >
                      {resultBranch &&
                        resultBranch.map((item, index) => (
                          <Card key={index} borderRadius="10px">
                            <CardBody
                              border="1px solid #E6E7E9"
                              borderRadius="10px"
                            >
                              <Flex
                                w="100%"
                                mb="0.75rem"
                                justifyContent="space-between"
                                alignItems="start"
                              >
                                <Box display="flex" flexDir="column">
                                  <Text fontSize="10px" color="gray.500">
                                    Branch name
                                  </Text>
                                  <Text
                                    fontSize="0.875rem"
                                    title={"item.partnername"}
                                    isTruncated
                                    fontWeight="600"
                                  >
                                    {item.clinicname}
                                  </Text>
                                </Box>
                                <Box display="flex" gap="10px">
                                  <Box
                                    as="button"
                                    border="1px solid #E6E7E9"
                                    borderRadius="full"
                                    w="36px"
                                    h="auto"
                                    p="10px"
                                    onClick={() => {
                                      openEditBranch(item);
                                    }}
                                  >
                                    <Image
                                      w="13px"
                                      src="/assets/imgs/edit-gray.png"
                                    />
                                  </Box>
                                </Box>
                              </Flex>
                              <Box display="flex" flexDir="column">
                                <Text fontSize="10px" color="gray.500">
                                  Branch Address
                                </Text>
                                <Text fontSize="0.875rem" fontWeight="600">
                                {item.address1 || item.address2 || item.city || item.state || item.pincode || item.country ? (
                                <>
                                  {item.address1 && `${item.address1}, `}
                                  {item.address2 && `${item.address2}, `}
                                  {item.city && `${item.city}, `}
                                  {item.state && `${item.state}, `}
                                  {item.pincode && `${item.pincode}, `}
                                  {item.country && `${item.country} `}
                                </>
                                ) : '-' }
                                </Text>
                              </Box>
                            </CardBody>
                          </Card>
                        ))}
                    </SimpleGrid>
                  </Box>
                </>
              ) : (
                <Box width="100%">
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    py="2rem"
                  >
                    <Text fontSize="md" fontWeight="bold">
                      No Branch Found
                    </Text>
                  </Box>
                </Box>
              )}
            </Box>
          </Flex>
        </Box>
      ) : (
        <>
          <MobileNavbar />
          <MobileSecondaryNav
            header="Branches"
            // header="Locations"
            handlebackarrow={() => navigate(`/profile`)}
          />
          <Box
            w="100%"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            p="1rem"
            gap="0.75rem"
          >
            <SearchBar
              passInputPlace="Search by Branch, Admin, Address"
              onKeyDown={handleKeyDown}
              onChange={(e) => handleChangeName(e)}
              handleClick={() => handleFilter()}
              searchValue={searchValue}
              placeholderMaxWidth="170px"
            />
            {searchValue && searchValue.length > 0 && (
              <PrimaryButton
                buttonText="X"
                id="resetButton"
                variant="grayBtn"
                btnStyle={{ color: "#AA2F27", m: "0", w: "50px" }}
                onClick={() => resetFeilds()}
              />
            )}
            <PrimaryButton
              buttonText="Add"
              onClick={openAddBranchModal}
              variant="mdBtn"
              btnStyle={{ w: "100%", maxW: "75px" }}
              //  isDisabled={actionAccess && !actionAccess.create ? true : false}
            />
          </Box>
          <Divider />
          {resultBranch && resultBranch.length > 0 ? (
            <>
              <Box
                width="100%"
                p="1rem"
                overflow="hidden auto"
                h="calc(100vh - 155px)"
              >
                <SimpleGrid
                  columns={{ base: 1, md: 2, lg: 3, xl: 4 }}
                  spacing="1rem"
                >
                  {resultBranch &&
                    resultBranch.map((item, index) => (
                      <Card key={index} borderRadius="10px">
                        <CardBody
                          border="1px solid #E6E7E9"
                          borderRadius="10px"
                        >
                          <Flex
                            w="100%"
                            mb="0.75rem"
                            justifyContent="space-between"
                            alignItems="start"
                          >
                            <Box display="flex" flexDir="column">
                              <Text fontSize="10px" color="gray.500">
                                Branch name
                              </Text>
                              <Text
                                fontSize="0.875rem"
                                title={"item.partnername"}
                                isTruncated
                                fontWeight="600"
                              >
                                {item.clinicname}
                              </Text>
                            </Box>
                            <Box display="flex" gap="10px">
                              <Box
                                as="button"
                                border="1px solid #E6E7E9"
                                borderRadius="full"
                                w="36px"
                                h="auto"
                                p="10px"
                                onClick={() => {
                                  openEditBranch(item);
                                }}
                              >
                                <Image
                                  w="13px"
                                  src="/assets/imgs/edit-gray.png"
                                />
                              </Box>
                            </Box>
                          </Flex>
                          <Box display="flex" flexDir="column">
                            <Text fontSize="10px" color="gray.500">
                              Branch Address
                            </Text>
                            <Text fontSize="0.875rem" fontWeight="600">
                              {item.city}, {item.STATE}, {item.country}
                            </Text>
                          </Box>
                        </CardBody>
                      </Card>
                    ))}
                </SimpleGrid>
              </Box>
            </>
          ) : (
            <Box width="100%">
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                py="2rem"
              >
                <Text fontSize="md" fontWeight="bold">
                  No Branch Found
                </Text>
              </Box>
            </Box>
          )}
        </>
      )}

      <ModalRight
        ref={addBranch}
        header="Add Branch"
        modalWidth={{ base: "100%", lg: "calc(100vw - 40%)" }}
        body={
          <>
            <Box display="flex" gap="1rem" w="100%" py="1rem">
              <Box w="100%">
                <Text mb="1rem" fontSize="1rem" fontWeight="600">
                  Admin details
                </Text>
                <Box w="100%" display="flex">
                  <PrimaryInput
                    inputPlace="Enter First Name*"
                    variant="leftSide"
                    inputValue={firstname}
                    onChange={(e) =>
                      setfirstname(handleAlphaDotAndSpace(e.target.value))
                    }
                  />

                  <PrimaryInput
                    inputPlace="Enter Last Name"
                    variant="rightSide"
                    inputValue={lastname}
                    onChange={(e) =>
                      setlastname(handleAlphaDotAndSpace(e.target.value))
                    }
                  />
                </Box>

                <Box w="100%" display="flex">
                  <PrimaryInput
                    inputPlace="Enter Email*"
                    variant="bothSide"
                    inputValue={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Box>
                <Box w="100%" display="flex">
                  {/* <PrimaryInput inputPlace="Password*" variant="bothSide"
                    inputValue={password} onChange={(e) => setPassword(e.target.value)} 
                  /> */}
                  <PasswordInput
                    passInputPlace="Enter Your Password*"
                    variant="bothSide"
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </Box>

                <Box w="100%" display="flex">
                  <DropdownInput
                    variant="bothSide"
                    dropDownPlace="Gender*"
                    options={["Male", "Female", "Others"]}
                    readOnly={true}
                    id="gender"
                    onClick={selectGender}
                    defaultOption={gender}
                    menuList={{
                      pos: "absolute",
                      right: "-45px",
                      minW: "115px",
                    }}
                  />
                </Box>

                <Box w="100%" display="flex">
                  <DatePicker
                    disableFutureDates={true}
                    placeholderProp="Date of Birth*"
                    leftPos={{ left: "5px" }}
                    datePickerInputStyle={{ borderRadius: "0!important" }}
                    onDateChange={(e) => handleDateChange(e)}
                    defaultDate={dobBranch}
                  />
                </Box>
                <Box w="100%" display="flex">
                  <PrimaryInputDropdown
                    onChange={(e) => handleMobileChange(e)}
                    inputValue={mobileno}
                    id="mobile"
                    variant="downSide"
                    placeholderProp="Phone number*"
                  />
                </Box>
              </Box>

              <Center height="auto">
                <Divider orientation="vertical" />
              </Center>

              <Box w="100%">
                <Text mb="1rem" fontSize="1rem" fontWeight="600">
                  Branch details
                </Text>
                <Box w="100%" display="flex">
                  <PrimaryInput
                    inputPlace="Branch Name*"
                    variant=""
                    inputValue={branchName}
                    onChange={(e) => setBranchName(e.target.value)}
                  />
                </Box>

                <Box w="100%" display="flex">
                  <PrimaryInput
                    inputPlace="Address 1*"
                    variant="bothSide"
                    // defaultValue={addressData.address1}
                    inputValue={branchAddress1}
                    onChange={(e) => setBranchAddress1(e.target.value)}
                    maxLength={50}
                  />
                </Box>

                <Box w="100%" display="flex">
                  <PrimaryInput
                    variant="bothSide"
                    inputPlace="Address 2"
                    // defaultValue={addressData.address2}
                    inputValue={branchAddress2}
                    onChange={(e) => setBranchAddress2(e.target.value)}
                    maxLength={50}
                  />
                </Box>

                <Box w="100%" display="flex">
                  <PrimaryInput
                    variant="bothSide"
                    inputPlace="City*"
                    // defaultValue={addressData.city}
                    inputValue={branchCity}
                    onChange={(e) =>
                      setBranchCity(handleAlphaDotAndSpace(e.target.value))
                    }
                    maxLength={50}
                  />
                </Box>

                <Box w="100%" display="flex">
                  <PrimaryInput
                    variant="bothSide"
                    inputPlace="State*"
                    // defaultValue={addressData.state}
                    inputValue={branchState}
                    onChange={(e) =>
                      setBranchState(handleAlphaDotAndSpace(e.target.value))
                    }
                    maxLength={50}
                  />
                  <PrimaryInput
                    variant="bothSide"
                    inputPlace="Pin Code*"
                    // defaultValue={addressData.pincode}
                    inputValue={branchPinCode}
                    onChange={(e) =>
                      setBranchPinCode(handleNumericDotAndSpace(e.target.value))
                    }
                    maxLength={6}
                  />
                </Box>

                <Box w="100%" display="flex">
                  <PrimaryInput
                    variant="downSide"
                    inputPlace="Country*"
                    // defaultValue={addressData.country}
                    inputValue={branchCountry}
                    onChange={(e) =>
                      setBranchCountry(handleAlphaDotAndSpace(e.target.value))
                    }
                    maxLength={50}
                  />
                </Box>
              </Box>
            </Box>
          </>
        }
        footerActions={
          <>
            <Flex gap="1.5rem" w="100%">
              <PrimaryButton
                buttonText="Add Branch"
                onClick={addBranchFunction}
              />
            </Flex>
          </>
        }
      />
      <ModalRight
        ref={editBranch}
        header="Edit Branch"
        modalWidth={{ base: "100%", lg: "calc(100vw - 70%)" }}
        body={
          <>
            <Box w="100%" py="1rem">
              <Box w="100%" display="flex">
                <PrimaryInput
                  inputPlace="Enter First Name*"
                  variant="leftSide"
                  inputValue={firstname}
                  defaultValue={firstname}
                  onChange={(e) =>
                    setfirstname(handleAlphaDotAndSpace(e.target.value))
                  }
                />

                <PrimaryInput
                  inputPlace="Enter Last Name"
                  variant="rightSide"
                  inputValue={lastname}
                  defaultValue={lastname}
                  onChange={(e) =>
                    setlastname(handleAlphaDotAndSpace(e.target.value))
                  }
                />
              </Box>

              <Box w="100%" display="flex">
                <PrimaryInput
                  inputPlace="Enter Email*"
                  variant="bothSide"
                  inputValue={email}
                  defaultValue={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Box>
              <Box w="100%" display="flex">
                <DropdownInput
                  variant="bothSide"
                  dropDownPlace="Gender*"
                  options={["Male", "Female", "Others"]}
                  readOnly={true}
                  id="gender"
                  onClick={selectGender}
                  defaultOption={gender}
                  menuList={{ pos: "absolute", right: "-45px", minW: "115px" }}
                />

                <DatePicker
                  disableFutureDates={true}
                  placeholderProp="Date of Birth*"
                  leftPos={{ left: "5px" }}
                  datePickerInputStyle={{ borderRadius: "0!important" }}
                  onDateChange={(e) => handleDateChange(e)}
                  defaultDate={dobBranch}
                />
              </Box>

              <Box w="100%" display="flex">
                <PrimaryInputDropdown
                  onChange={(e) => handleMobileChange(e)}
                  inputValue={mobileno}
                  defaultValue={mobileno}
                  id="mobile"
                  variant="downSide"
                  placeholderProp="Phone number*"
                />
              </Box>
              <Box w="100%" display="flex">
                <PrimaryInput
                  inputPlace="Branch Name*"
                  variant="bothSide"
                  inputValue={branchName}
                  defaultValue={branchName}
                  onChange={(e) => setBranchName(e.target.value)}
                />
              </Box>

              <Box w="100%" display="flex">
                <PrimaryInput
                  inputPlace="Address 1*"
                  defaultValue={branchAddress1}
                  inputValue={branchAddress1}
                  onChange={(e) => setBranchAddress1(e.target.value)}
                  maxLength={50}
                />
              </Box>

              <Box w="100%" display="flex">
                <PrimaryInput
                  variant="bothSide"
                  inputPlace="Address 2"
                  defaultValue={branchAddress2}
                  inputValue={branchAddress2}
                  onChange={(e) => setBranchAddress2(e.target.value)}
                  maxLength={50}
                />
              </Box>

              <Box w="100%" display="flex">
                <PrimaryInput
                  variant="bothSide"
                  inputPlace="City*"
                  defaultValue={branchCity}
                  inputValue={branchCity}
                  onChange={(e) =>
                    setBranchCity(handleAlphaDotAndSpace(e.target.value))
                  }
                  maxLength={50}
                />
              </Box>

              <Box w="100%" display="flex">
                <PrimaryInput
                  variant="bothSide"
                  inputPlace="State"
                  defaultValue={branchState}
                  inputValue={branchState}
                  onChange={(e) =>
                    setBranchState(handleAlphaDotAndSpace(e.target.value))
                  }
                  maxLength={50}
                />
              </Box>

              <Box w="100%" display="flex">
                <PrimaryInput
                  variant="bothSide"
                  inputPlace="Pin Code*"
                  // defaultValue={branchPinCode}
                  inputValue={branchPinCode}
                  onChange={(e) =>
                    setBranchPinCode(handleNumericDotAndSpace(e.target.value))
                  }
                  maxLength={6}
                />
              </Box>

              <Box w="100%" display="flex">
                <PrimaryInput
                  variant="downSide"
                  inputPlace="Country*"
                  // defaultValue={branchCountry}
                  inputValue={branchCountry}
                  onChange={(e) =>
                    setBranchCountry(handleAlphaDotAndSpace(e.target.value))
                  }
                  maxLength={50}
                />
              </Box>
            </Box>
          </>
        }
        footerActions={
          <>
            <Flex gap="1.5rem" w="100%">
              <PrimaryButton
                buttonText="Edit Branch"
                onClick={editBranchFunction}
              />
            </Flex>
          </>
        }
      />

      <DynamicModal
        // ref={deletePartner}
        modalHeader="Delete Branch"
        modalBody={
          <>
            <Text fontSize="14px" fontWeight="600">
              {/* Are you sure you want to delete Branch "{partnerName}" ? */}
            </Text>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              variant="deleteBtn"
              buttonText="Delete"
              // onClick={deletePartnerFromList}
            />
          </>
        }
      />
    </>
  );
};

export default MasterBranches;
